"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoyaltyRewardsLedgerEntryDto = void 0;
const AppDto_1 = require("../apps/AppDto");
const CustomerProfileDto_1 = require("../customer-profiles/CustomerProfileDto");
const LocationDto_1 = require("../locations/LocationDto");
const LoyaltyRewardsTasksDto_1 = require("../loyalty-rewards-and-tasks/LoyaltyRewardsTasksDto");
class LoyaltyRewardsLedgerEntryDto {
    constructor(params) {
        this.locationName = "";
        this.title = "";
        this.description = "";
        this.createdAt = "";
        this.updatedAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.appId = params.appId;
        this.loyaltyRewardOrTaskId = params.loyaltyRewardOrTaskId;
        this.customerProfileId = params.customerProfileId;
        this.customerId = params.customerProfileId || params.customerId;
        this.locationId = params.locationId;
        this.locationName = params.locationName;
        this.title = params.title;
        this.description = params.description;
        this.points = params.points;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        if (params.app !== undefined) {
            this.app = params.app === null ?
                null :
                new AppDto_1.AppDto(params.app);
        }
        if (params.loyaltyRewardOrTask !== undefined) {
            this.loyaltyRewardOrTask = params.loyaltyRewardOrTask === null ?
                null :
                new LoyaltyRewardsTasksDto_1.LoyaltyRewardsTasksDto(params.loyaltyRewardOrTask);
        }
        if (params.customerProfile !== undefined) {
            this.customerProfile = params.customerProfile === null ?
                null :
                new CustomerProfileDto_1.CustomerProfileDto(params.customerProfile);
        }
        if (params.location !== undefined) {
            this.location = params.location === null ?
                null :
                new LocationDto_1.LocationDto(params.location);
        }
    }
}
exports.LoyaltyRewardsLedgerEntryDto = LoyaltyRewardsLedgerEntryDto;
//# sourceMappingURL=LoyaltyRewardsLedgerEntryDto.js.map